module.exports = __webpack_public_path__ + "static/blogs-510fa161591e251529c33f31596f13dc.jpg";